<template>
	<div class="leave-calendar-item-container">
		<ProgressGetDataLinear v-if="loading" class="px-5"/>
		<div v-if="!loading" class="leave-calendar-item-column px-3">
			<div class="leave-calendar-item-row">
				<div class="leave-calendar-item-text leave-calendar-item-color">{{leave.type_desc}}&nbsp;&nbsp;{{ leave.duration_fmt }}</div>
				<TaskCalendarItemMenu
					v-if="!leave.leave_paid"
					:type="event_leave"
					:privileges="privileges"
					:isApproved="leave.leave_approved"
					:isPaid="leave.leave_paid"
					@click-menu-item="onClickMenuItem($event)"
					@delete="onDeleteMenuItem()"/>
			</div>
			<v-alert type="error" v-if="error_msg.length !== 0" dense style="width: 100%">
				{{ error_msg }}
			</v-alert>
			<div v-if="!leave.leave_approved" class="leave-calendar-item-sub-text leave-calendar-item-color" style="font-weight: 700">Pending approval</div>
			<v-divider class="leave-divider my-1"></v-divider>
			<div class="leave-calendar-item-row">
				<div class="py-1">
					<div class="leave-calendar-item-sub-text leave-calendar-item-main-color">{{ formatDate(leave.start_date) }}</div>
					<div v-if="!leave.all_day" class="leave-calendar-item-sub-text leave-calendar-item-main-color">{{ formatHours(leave.start_datetime) }}</div>
				</div>
				<div class="py-1">
					<div class="leave-calendar-item-sub-text leave-calendar-item-sub-color">to</div>
				</div>
				<div class="py-1">
					<div class="leave-calendar-item-sub-text leave-calendar-item-main-color">{{ formatDate(leave.end_date) }}</div>
					<div v-if="!leave.all_day" class="leave-calendar-item-sub-text leave-calendar-item-main-color">{{ formatHours(leave.end_datetime) }}</div>
				</div>
			</div>
			<v-divider v-if="isCurrentUser || isPrivilege" class="leave-divider my-1"></v-divider>
			<div v-if="isCurrentUser || isPrivilege" class="leave-calendar-item-sub-text leave-calendar-item-color desc-over-text">{{ leave.description }}</div>
			<v-select
				v-if="isPrivilege && !leave.leave_paid && !leave.pay_processed"
				style="width: 70%;"
				class=" my-2"
				v-model="approve_select"
				:items="approve_option"
				:item-color="color"
				:color="'#FFFFFF'"
				:background-color="color"
				:menu-props="{ bottom: true, offsetY: true}"
				append-icon="mdi-chevron-down"
				dense
				hide-details
				return-object
				solo
				@click.stop
			/>
		</div>
	</div>
</template>
<script>
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import TaskCalendarItemMenu from "@/views/timesheets/calendar_item_menu.vue";
import moment from 'moment';

const Approve_Option = [
	{
		text: 'Approved',
		value: 'approved',
	},
	{
		text: 'Unapproved',
		value: 'unapprove',
	}
];
const Event_Leave = 'leave';

/** If selected the user can only modify events he/she owns (has created) */
const EVOwn = 'EVOwn';

/** If selected the user can manage and approve leave events */
const DAppLeave = 'DAppLeave';

/** If selected the user can delete approved leave events if not already in a payslip */
const DDelAppLeave = 'DDelAppLeave';

export default {
	name: 'CalendarLeaveItem',
	props: {
		leave: {
			type: Object,
			default: () => {}
		},
		isCurrentUser: {
			type: Boolean,
			default: false
		},
		currentUserId: {
			type: Number,
			default: 0
		}, 
		privileges: {
			type: Array,
			default: () => []
		},
		color: {
			type: String,
			default: 'rgba(25, 42, 62, 0.7)'
		},
	},
	data() {
		this.event_leave = Event_Leave;
		this.approve_option = Approve_Option;

		return {
			loading: false,
			error_msg: '',
			approve_select: this.leave.leave_approved ? Approve_Option[0] : Approve_Option[1]
		}
	},
	components: {
		ProgressGetDataLinear,
		TaskCalendarItemMenu
	},
	computed: {
		isPrivilege() {
			let isPrivilege_tmp = false;
			
			if (this.privileges.length !== 0) {
				if (this.privileges.includes(DAppLeave)) {
					isPrivilege_tmp = true;
				}
			}
			
			return isPrivilege_tmp;
		}
	},
	watch: {
		approve_select() {
			if (this.isPrivilege) {
				this.$emit('click-menu-item', this.approve_select.value);
			}
		}
	},
	methods: {
		formatDate(value) {
			if(!value) return null;
			return moment(value).format('DD MMM YYYY');
		},
		formatHours(value) {
			if(!value) return null;
			return moment(value, 'YYYYMMDD HH:mm:ss').format('HH:mm');
		},
		formatMinutes(value) {
			let result = 0;
			const isNegtive = value < 0 ? true : false;

			const value_tmp = Math.abs(value);
			if (value_tmp < 60 && value_tmp >= 0) {
				result = `${value_tmp}m`;
			}

			if (value_tmp >= 60) {
				const hours = Math.floor(value_tmp / 60);
				const minutes =  Math.floor(value_tmp - (hours * 60));
				result = minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
			}

			return isNegtive ? '-'+result : result;
		},
		onClickMenuItem(key) {
			if (key === 'edit') {
				const path = this.$route.path;
				this.$router.push({ name: "Edit Leave", params: { id: this.leave.id, path: path } });
			}
			if (key === 'approved') {
				this.$emit('click-menu-item', key);
			}	
			if (key === 'unapprove') {
				this.$emit('click-menu-item', key);
			}
		},
		onDeleteMenuItem() {
			let is_able = false;

			if (this.leave.leave_approved) {
				is_able = this.privileges.includes(DDelAppLeave) ? true : false;
			} else {
				if (this.isCurrentUser) {
					is_able = true;
				} else {
					if (this.privileges.includes(EVOwn)) {
						is_able = false;
					} else {
						is_able = this.privileges.includes(DAppLeave) ? true: false;
					}
				}
			}
				
			if (!this.leave.leave_paid && is_able) {
				this.$emit('delete-leave', this.leave);
			}
		},
	}
}
</script>
<style lang="scss" scoped>
 .leave-calendar-item-container {
  width: 100%;
	height: 100%;
  background: #FFFFFF;
  border: 1px solid rgba(255, 185, 70, 0.5);
  box-shadow: 0px 2px 4px rgba(25, 42, 62, 0.12);
  border-radius: 4px;
}
.leave-calendar-item-column {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
}
.leave-time {
  width: 100%; 
  height: 100%;
  margin: 0;
}
.leave-divider {
  width: 100%; 
  border-color: rgba(25, 42, 62, 0.3); 
} 
.leave-calendar-item-row {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.leave-calendar-item-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.leave-calendar-item-sub-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
}
.leave-calendar-item-color {
  color: #C18014;
}
.leave-calendar-item-main-color {
  color: #192A3E;
}
.leave-calendar-item-sub-color {
  color: rgba(25, 42, 62, 0.7);
}
.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.desc-over-text {
	width: 100%;
	text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
::v-deep {
	.theme--light.v-select .v-select__selections {
		color: #FFFFFF;
		font-family: Roboto;
		font-size: 14px;
		font-weight: 500;
	}
	.theme--light.v-icon {
		color: #FFFFFF;
	}
	.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
		min-height: 32px;
	}
}

</style>